import React, { useCallback, useMemo } from "react";
import { useAccount } from "wagmi";

import { useStoreSelector } from "../../store/store";
import { Header } from "../UI/Header/Header";
import { whiteList } from "../../settings";

import './RegisterPage.scss';

const RegisterPage: React.FC = () => {
  const { chrClientAddr } = useStoreSelector(store => store.app);
	
	const { address } = useAccount();


  const checkWhiteList = useCallback(() => {
    if (whiteList.find((whiteAddr) => whiteAddr.toLocaleLowerCase() === address?.toLocaleLowerCase()))
      return true
      else return false
  },[address])

  const isInWhiteList = useMemo( () => {
    return checkWhiteList()
  },[checkWhiteList])

	return(
      <div className="RegisterPage">
        <Header/>

        {!chrClientAddr &&
          <div className="buttonWrapper">
            {/* {isInWhiteList ? */}
                <div className="registerButton__wrapper">
                  <button onClick={() => {}}>
                    <a className="register-link" target="_blank" rel="noreferrer" href='https://slurpyswap.com/register'>
                      Register Account
                    </a>
                  </button>
                </div>
                {/* : isInWhiteList === false && 'Currently only the accounts in the whitelist can use the product' */}
            {/* } */}
          </div>
        }
      </div>
	)
}

export default RegisterPage;